export const Constants = {
    DefaultGeoCoordinates: '59.3274533,18.0521569',
    DefaultWATime: 60,
}